import React, { Fragment } from 'react';
import { Modal, Card, Row, Col } from 'antd';
import { connect } from 'dva';
import { formatPrice } from 'utils/utils.js';
import styles from './Index.less';

@connect(({ GoodsDetailModal, loading }) => ({
  detail: GoodsDetailModal.detail,
  visible: GoodsDetailModal.visible,
  contentLoading: loading.effects['GoodsDetailModal/fetchGoodsDetail'],
}))
export default class GoodsDetailModal extends React.Component {
  static handlePreviewImg(url) {
    window.open(url);
  }

  constructor(props) {
    super(props);

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.renderSkus = this.renderSkus.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  handleCloseModal() {
    this.props.dispatch({
      type: 'GoodsDetailModal/toggleModalVisibility',
      visible: false,
    });
  }

  renderSkus() {
    const { skus } = this.props.detail;
    let resultStr = '';

    if (skus) {
      skus.forEach((item, index, arr) => {
        item.specifications.forEach((specItem, specIndex, specArr) => {
          if (specIndex === specArr.length - 1) {
            resultStr += `${specItem.value}`;
          } else {
            resultStr += `${specItem.value}-`;
          }
        });
        if (index === arr.length - 1) {
          resultStr += `(${formatPrice(item.originalPrice)}元)`;
        } else {
          resultStr += `(${formatPrice(item.originalPrice)}元) / `;
        }
      });
    }

    return resultStr === '' ? '无' : resultStr;
  }

  renderContent() {
    const { detail } = this.props;

    if (detail === null) {
      return null;
    }

    const { merchantName, name, images, price, description, skus } = detail;

    const imagesComponent = images.split(',').map(item => {
      return (
        <img
          className={styles['detail-img']}
          key={item}
          alt="img"
          src={item}
          onClick={GoodsDetailModal.handlePreviewImg.bind(null, item)}
        />
      );
    });

    let minPrice = null;
    let maxPrice = null;
    if (skus) {
      skus.forEach(q => {
        if (minPrice == null || minPrice > q.originalPrice) {
          minPrice = q.originalPrice;
        }

        if (maxPrice == null || maxPrice < q.originalPrice) {
          maxPrice = q.originalPrice;
        }
      });
    }

    let finalPrice;
    if (skus && skus.length === 1) {
      finalPrice = `${formatPrice(minPrice)}`;
    } else if (skus && skus.length > 1) {
      finalPrice = `${formatPrice(minPrice)} ~ ${formatPrice(maxPrice)}`;
    } else {
      finalPrice = `${formatPrice(price)}`;
    }

    return (
      <Fragment>
        <Row>
          <Col md={8} xs={24}>
            <p className={styles['detail-label']}>商户</p>
          </Col>
          <Col md={16} xs={24}>
            <p className={styles['detail-content']}>{merchantName || '无'}</p>
          </Col>
        </Row>
        <Row>
          <Col md={8} xs={24}>
            <p className={styles['detail-label']}>商品名称</p>
          </Col>
          <Col md={16} xs={24}>
            <p className={styles['detail-content']}>{name || '无'}</p>
          </Col>
        </Row>
        <Row>
          <Col md={8} xs={24}>
            <p className={styles['detail-label']}>图片</p>
          </Col>
          <Col md={16} xs={24}>
            <p className={styles['detail-content']}>{imagesComponent}</p>
          </Col>
        </Row>
        <Row>
          <Col md={8} xs={24}>
            <p className={styles['detail-label']}>价格(元)</p>
          </Col>
          <Col md={16} xs={24}>
            <p className={styles['detail-content']}>{finalPrice}</p>
          </Col>
        </Row>
        <Row>
          <Col md={8} xs={24}>
            <p className={styles['detail-label']}>规格</p>
          </Col>
          <Col md={16} xs={24}>
            <p className={styles['detail-content-skus']}>{this.renderSkus()}</p>
          </Col>
        </Row>
        <Row>
          <Col md={8} xs={24}>
            <p className={styles['detail-label']}>产品描述</p>
          </Col>
          <Col md={16} xs={24}>
            <p
              className={styles['detail-content']}
              dangerouslySetInnerHTML={(() => ({ __html: description || '<p>无</p>' }))()}
            />
          </Col>
        </Row>
      </Fragment>
    );
  }

  render() {
    const { contentLoading } = this.props;
    const { visible } = this.props;

    if (visible !== true) {
      return null;
    }

    return (
      <Modal
        className={styles.root}
        title="商品详情"
        visible
        footer={null}
        onCancel={this.handleCloseModal}
      >
        <Card bordered={false} loading={contentLoading}>
          {this.renderContent()}
        </Card>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/GoodsDetailModal/Index.js